import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Fair prices, on purpose",
    body: "We keep margins honest and overheads low, so the price on the tag reflects the object — not the showroom it sat in.",
  },
  {
    n: "02",
    title: "Made to be lived with",
    body: "Every piece is chosen for how it ages: solid wood that scars beautifully, linen that softens, glazes that deepen.",
  },
  {
    n: "03",
    title: "Local, by hand",
    body: "We deliver across New York ourselves. No couriers tossing boxes — your pieces arrive placed, not dropped.",
  },
];

const MANIFESTO_IMAGE =
  "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?q=80&w=900&h=1200&auto=format&fit=crop";

export const Manifesto = () => (
  <section id="story" data-testid="manifesto-section" className="bg-charcoal py-24 text-bone sm:py-32">
    <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
      <Reveal>
        <p className="mb-4 text-xs uppercase tracking-[0.3em] text-bone/60">Our philosophy</p>
        <h2 className="mb-20 max-w-2xl font-serif text-3xl font-light leading-tight tracking-tight sm:text-4xl lg:text-5xl">
          A home isn't decorated.<br />It's gathered.
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
        <div className="lg:col-span-7">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="flex gap-8 border-t border-bone/15 py-10 sm:gap-14">
                <span className="font-serif text-5xl font-light italic text-moss sm:text-6xl">{c.n}</span>
                <div>
                  <h3 className="font-serif text-xl tracking-tight sm:text-2xl">{c.title}</h3>
                  <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-bone/70">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <div className="overflow-hidden">
            <img
              src={MANIFESTO_IMAGE}
              alt="A calm bedroom gathered piece by piece"
              loading="lazy"
              className="h-full max-h-[560px] w-full object-cover transition-transform duration-700 ease-out hover:scale-105"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
